import React from "react"
import { useNoteContext } from "./note-context"
import { cva } from "class-variance-authority"

// =============================================================================
// Styles
// =============================================================================

const contentStyles = cva(
  "[grid-area:content] flex flex-col gap-1 text-sm leading-6",
  {
    variants: {
      layout: {
        horizontal: "",
        stacked: "",
        inline:
          "only:px-2 @5xl/note:flex-row @5xl/note:items-center @5xl/note:gap-2"
      }
    }
  }
)

// =============================================================================
// Props
// =============================================================================
export type NoteContentProps = {
  children: React.ReactNode
  className?: string
}

export function NoteContent({ children, className }: NoteContentProps) {
  const { layout } = useNoteContext()
  return (
    <div
      className={contentStyles({ layout, className })}
      data-slot="note-content"
    >
      {children}
    </div>
  )
}
